<template>
  <Teleport to="body">
    <Transition name="modal">
      <div
        v-if="isOpen"
        class="fixed left-0 top-0 z-popup flex h-full w-full items-center justify-center bg-black/60"
        @click.self="handleClickMask"
      >
        <div
          class="relative max-h-[calc(100%-40px)] w-[calc(100%-40px)] overflow-hidden rounded-lg bg-white transition-all duration-300 ease-in"
          :class="hasSpace && 'px-5 py-2.5'"
          :style="{ maxWidth: maxWidth, minHeight: minHeight }"
        >
          <slot />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
  interface IProps {
    isOpen: boolean;
    maxWidth?: string;
    minHeight?: string;
    hasSpace?: boolean;
    maskClosable?: boolean;
  }

  const props = withDefaults(defineProps<IProps>(), {
    maxWidth: '600px',
    minHeight: '300px',
    hasSpace: true,
    maskClosable: true,
  });

  const emits = defineEmits<{
    (e: 'close'): void;
  }>();

  const mainStore = useMainStore();

  const handleClickMask = (): void => {
    if (props.maskClosable) {
      emits('close');
    }
  };

  watch(
    () => props.isOpen,
    (value: boolean) => {
      mainStore.isBodyFixed = value;
    }
  );
</script>
